import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalDirective, ModalOptions } from '@hs/ui-core-layout';
import { IconComponent } from '@hs/ui-core-presentation';

@Component({
    selector: 'ddv-refresh-restore',
    templateUrl: './refresh-restore.component.html',
    styleUrls: ['./refresh-restore.component.scss'],
    imports: [
        IconComponent,
        ModalDirective,
    ],
})
export class RefreshRestoreComponent implements AfterViewInit {
    @Input() showRestore = true;

    @Output() refresh = new EventEmitter<void>();
    @Output() restore = new EventEmitter<void>();

    protected showRestoreModal = false;
    protected modalOptions: ModalOptions = {};

    @ViewChild('restoreIcon', { static: false, read: ElementRef }) private readonly icon: ElementRef<HTMLElement> | undefined;

    ngAfterViewInit(): void {
        this.modalOptions = {
            anchorToElement: this.icon?.nativeElement,
            position: 'bottom-right',
            customWidth: 15,
        };
    }

    protected onRestoreClick(): void {
        this.showRestoreModal = false;
        this.restore.emit();
    }
}

